$bog_prof_theme_auto $mol_theme_auto
	light \$mol_theme_light
	dark \$mol_theme_dark
